import React from 'react'

import { number, string } from 'prop-types'

import WithTriangleUiContext from 'Pods/Shared/Hocs/WithTriangleUiContext'
import i18n from 'Pods/Shared/I18n'


function NumberOfItems({ totalCount, locale = 'en' }) {
  const items = i18n.t('listingPage.filters.items', { ns: 'rails', lng: locale })
  return (
    <div className="metaverse-pagination-new__number-of-items">
      <span className="cgt-legacy-heading-h6">
        {`${totalCount} ${items}`}
      </span>
    </div>
  )
}

NumberOfItems.propTypes = {
  totalCount: number.isRequired,
  locale: string,
}

const mapStateToProps = ({ currentMeta: { totalCount }, locale }) => {
  return { totalCount, locale }
}

export default WithTriangleUiContext(mapStateToProps)(NumberOfItems)
